import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Spinner } from "reactstrap";

/**
 * TransferModal
 * Modal para selecionar o colaborador destino da transferência.
 */
const TransferModal = ({
    isOpen,
    toggle,
    employees,
    currentEmployeeId,
    selectedCount,
    onConfirm,
    isTransferring
}) => {
    const [targetEmployeeId, setTargetEmployeeId] = useState("");

    // Filtrar o employee atual da lista de destinos
    const availableEmployees = employees.filter(e => e.id !== currentEmployeeId);

    const handleConfirm = () => {
        if (!targetEmployeeId) return;
        onConfirm(targetEmployeeId);
    };

    const handleClosed = () => {
        setTargetEmployeeId("");
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered onClosed={handleClosed}>
            <ModalHeader toggle={toggle} className="bg-light-subtle border-bottom">
                <i className="mdi mdi-account-switch-outline me-2 text-warning"></i>
                Transferir Clientes
            </ModalHeader>
            <ModalBody className="py-4">
                <div className="text-center mb-4">
                    <div className="avatar-md mx-auto mb-3">
                        <span className="avatar-title bg-warning bg-opacity-10 text-warning rounded-circle" style={{ fontSize: "32px" }}>
                            <i className="mdi mdi-account-switch"></i>
                        </span>
                    </div>
                    <p className="text-muted font-size-14 mb-0">
                        Você está transferindo <strong className="text-dark">{selectedCount} cliente(s)</strong> para outro consultor.
                    </p>
                </div>

                <div>
                    <label className="form-label fw-semibold text-muted font-size-12 text-uppercase">
                        Consultor de Destino
                    </label>
                    <Input
                        type="select"
                        value={targetEmployeeId}
                        onChange={(e) => setTargetEmployeeId(e.target.value)}
                        disabled={isTransferring}
                        className="form-select"
                    >
                        <option value="">Selecione o novo consultor...</option>
                        {availableEmployees.map(emp => (
                            <option key={emp.id} value={emp.id}>
                                {emp.fullName || `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.email}
                            </option>
                        ))}
                    </Input>
                </div>
            </ModalBody>
            <ModalFooter className="border-top">
                <Button color="light" onClick={toggle} disabled={isTransferring} className="fw-medium">
                    Cancelar
                </Button>
                <Button
                    color="warning"
                    onClick={handleConfirm}
                    disabled={!targetEmployeeId || isTransferring}
                    className="fw-semibold text-white"
                >
                    {isTransferring ? (
                        <><Spinner size="sm" className="me-2" /> Transferindo...</>
                    ) : (
                        <><i className="mdi mdi-check me-1"></i> Confirmar Transferência</>
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default TransferModal;
